// /common
import './navigation';
// import './lazy-load';
import './carousels';
import './accordion';
import './cookies';


const $ = jQuery;
// jQuery(function ($) {
$(document).ready(function(){

    // read-more scroll
    $('.read-more-scroll').click(function () {
      var targetOffset = $("#read-more").offset().top - 170;
    	$('html, body').animate({
          scrollTop: targetOffset
    	}, 600);
    });

  });
  